import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PjudService {

  constructor(private http: HttpClient) { }

  async getCauseForRit(rit: string, tribunal: string, court: string, competencie: string, book: string, customer: any): Promise<any> {
    let body = {
      rit,
      tribunal,
      court,
      competencie,
      book,
      customer
    }
    return await firstValueFrom(this.http.post(`${environment.apiUrl}/robotpjud/get`, body, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    }));
  }

  saveCause(obj) {
    return this.http.post(`${environment.apiUrl}/robotpjud/save`, obj, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }
}
